import { TimelineActionButton } from '../timeline-action-button/timeline-action-button.component';
import { TimelineDetailsBubble } from '../timeline-details-bubble/timeline-details-bubble.component';
import { TimelineIcon } from '../timeline-icon/timeline-icon.component';
import { TimelineMessage } from '../timeline-message/timeline-message.component';
import { TimelineQRBubble } from '../timeline-qr-bubble/timeline-qr-bubble.component';
import { TimelineSubtext } from '../timeline-subtext/timeline-subtext.component';
import { TimelineTitle } from '../timeline-title/timeline-title.component';
import { TimelineEventProps } from '../timeline.types';
import { useTimelineRowStyles } from './timeline-row.styles';

export function TimelineRow({
  title,
  titleBadge,
  message,
  subtext,
  availability,
  details,
  icon,
  messageBadge,
  qr,
  action,
  options
}: TimelineEventProps) {
  const classes = useTimelineRowStyles({ ...options, hasAvailability: availability !== undefined });
  return (
    <div className={classes.wrapper}>
      <div className={classes.row}>
        {availability !== undefined && <div className={classes.availability}>{availability}</div>}
        <div className={classes.icon}>
          <TimelineIcon {...icon} />
        </div>
        <div className={classes.content}>
          <TimelineTitle title={title} badge={titleBadge} />
          {message ? <TimelineMessage message={message} badge={messageBadge} /> : null}
          {subtext ? <TimelineSubtext text={subtext} /> : null}
          {details ? <TimelineDetailsBubble {...details} /> : null}
          {qr ? <TimelineQRBubble {...qr} /> : null}
          {action ? <TimelineActionButton {...action} /> : null}
        </div>
      </div>
      <div className={[classes.divider, classes.dividerStyle].join(' ')}></div>
    </div>
  );
}
